import dayjs from "dayjs";

export const NICKNAME_MAX_LENGTH = 255;

const DAY_MIN = 1;
const DAY_MAX = 31;
const MONTH_MIN = 1;
const MONTH_MAX = 12;
const YEAR_LENGTH = 4;
const AGE_MIN = 18;
const AGE_MAX = 120;

export const REQUIRED_TEXT_FIELDS = [
  "nickname",
  "first_name",
  "last_name",
];

export const PHONE_MIN_DIGITS = 7;

const PHONE_DIGIT_PLACEHOLDER = ".";

/*
 * Перевіряє телефон: digits — цифри без плюса,
 * country — { dialCode, format } з react-phone-input-2 або null.
 * Повертає ключ перекладу помилки або null.
 */
export const getPhoneErrorKey = (digits, country) => {
  const normalizedDigits =
    typeof digits === "string" ? digits.replace(/\D/g, "") : "";

  const dialCode = country?.dialCode || "";

  const subscriberDigits = normalizedDigits.startsWith(dialCode)
    ? normalizedDigits.slice(dialCode.length)
    : normalizedDigits;

  if (!normalizedDigits || !subscriberDigits) {
    return "profile.field_cannot_be_empty";
  }

  const expectedDigitsCount = (country?.format || "")
    .split("")
    .filter((symbol) => symbol === PHONE_DIGIT_PLACEHOLDER).length;

  const minimumDigitsCount =
    expectedDigitsCount > 0 ? expectedDigitsCount : PHONE_MIN_DIGITS;

  if (normalizedDigits.length < minimumDigitsCount) {
    return "profile.phone_incomplete";
  }

  return null;
};

/*
 * Повертає ключ перекладу помилки або null, якщо значення коректне.
 */
export const getTextFieldErrorKey = (fieldName, value) => {
  const normalizedValue =
    typeof value === "string" ? value.trim() : value;

  if (
    REQUIRED_TEXT_FIELDS.includes(fieldName) &&
    !normalizedValue
  ) {
    return "profile.field_cannot_be_empty";
  }

  if (
    fieldName === "nickname" &&
    normalizedValue.length > NICKNAME_MAX_LENGTH
  ) {
    return "profile.nickname_max_length";
  }

  return null;
};

/*
 * Повертає { errorKey } для некоректної дати
 * або { dateObject } для коректної.
 */
export const validateDateOfBirth = (dateParts, now = dayjs()) => {
  const { day = "", month = "", year = "" } = dateParts || {};

  if (!day || !month || !year) {
    return { errorKey: "profile.date_error_empty" };
  }

  const dayNumber = parseInt(day, 10);
  const monthNumber = parseInt(month, 10);

  if (dayNumber < DAY_MIN || dayNumber > DAY_MAX) {
    return { errorKey: "profile.date_error_day" };
  }

  if (monthNumber < MONTH_MIN || monthNumber > MONTH_MAX) {
    return { errorKey: "profile.date_error_month" };
  }

  if (year.length !== YEAR_LENGTH) {
    return { errorKey: "profile.date_error_year_format" };
  }

  const dateString =
    `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

  const dateObject = dayjs(dateString);

  const isExactDate =
    dateObject.isValid() &&
    dateObject.format("YYYY-MM-DD") === dateString;

  if (!isExactDate) {
    return { errorKey: "profile.date_error_invalid" };
  }

  if (dateObject.isAfter(now)) {
    return { errorKey: "profile.date_error_future" };
  }

  const age = now.diff(dateObject, "year");

  if (age < AGE_MIN) {
    return { errorKey: "profile.date_error_age_min" };
  }

  if (age > AGE_MAX) {
    return { errorKey: "profile.date_error_age_max" };
  }

  return { dateObject };
};
